import { render, staticRenderFns } from "./comments-section.vue?vue&type=template&id=09c346da&scoped=true"
import script from "./comments-section.vue?vue&type=script&lang=js"
export * from "./comments-section.vue?vue&type=script&lang=js"
import style0 from "./comments-section.vue?vue&type=style&index=0&id=09c346da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c346da",
  null
  
)

export default component.exports